$(document).ready(function () 
{

	window.onscroll = function() {myFunction()};

	var header = document.getElementById("site-header");
	var sticky = header.offsetTop;

	function myFunction() {
		if (window.pageYOffset > sticky) {
			header.classList.add("sticky");
		} else {
			header.classList.remove("sticky");
		}
	}

	var nav_span = $(".nav-span");

	$("#nav-toggler").click(function () 
	{
		if (nav_span.hasClass("nav-lines"))
		{
			nav_span.removeClass("nav-lines"); // make a cross
			nav_span.addClass("nav-cross"); // make a cross
			$('body').addClass('nav-toggle-is-active'); // set the class that allows overlays
		} 
		else 
		{
			nav_span.removeClass("nav-cross");
			nav_span.addClass("nav-lines");
			$('body').removeClass('nav-toggle-is-active');
		}
	});

	$(".mobile-submenu-toggle").each(function()
	{
	    $( this ).click(function (e) {
	        e.preventDefault();
	        var to_open = $(this).data( 'opennav' );
	        var should_open = $( to_open ).hasClass("mobile-submenu-off"); 

	        $('.mobile-submenu').addClass("mobile-submenu-off"); // hide all other submenus
	        $('.mobile-submenu-toggle').removeClass("mobile-submenu-toggle-on-show"); // return to plus icons
	       

	        if (should_open)
	        { 
	        	$( to_open ).removeClass("mobile-submenu-off"); // open this one
	        	$( this ).addClass("mobile-submenu-toggle-on-show"); // show minus icon
	        }
	    });
	});

	$(".search-trigger").on('click', function(e) {
		e.preventDefault();
		$(".search-container").toggleClass("active");
		$("html").toggleClass("no-scroll");
	});

	$(".search-close").on('click', function(e) {
		e.preventDefault();
		$(".search-container").removeClass("active");
		$("html").removeClass("no-scroll");
	});

});